export const countries = {
  dz: {
    name: 'Algeria',
    phoneNumbers: ['+213 9 82 40 23 80']
  },
  am: {
    name: 'Armenia',
    phoneNumbers: ['+33 972721019']
  },
  ar: {
    name: 'Argentina',
    phoneNumbers: ['0800 345 6581']
  },
  au: {
    name: 'Australia',
    phoneNumbers: ['1800 008 640']
  },
  at: {
    name: 'Austria',
    phoneNumbers: ['0800 100 440']
  },
  by: {
    name: 'Belarus',
    phoneNumbers: ['8 820 0011 0131']
  },
  be: {
    name: 'Belgium',
    phoneNumbers: ['0800 58 022']
  },
  ba: {
    name: 'Bosnia and Herzegovina',
    phoneNumbers: ['0800 82 842']
  },
  br: {
    name: 'Brazil',
    phoneNumbers: ['0800 881 7001, 08007248286']
  },
  bg: {
    name: 'Bulgaria',
    phoneNumbers: ['00800 11 51 165']
  },
  ca: {
    name: 'Canada',
    phoneNumbers: ['866 867 0461']
  },
  cl: {
    name: 'Chile',
    phoneNumbers: ['123 00 207 421', '+56 226 188 312']
  },
  cn: {
    name: 'China',
    phoneNumbers: [
      '10800 852 1028 - North Mainland China',
      '10800 852 2015 - North Mainland China',
      '10800 152 1028 - South China',
      '10800 152 2015 - South China',
      '4009198418 - Cell'
    ]
  },
  co: {
    name: 'Colombia',
    phoneNumbers: ['01800 933 0205', '+ 57 601 508 7862']
  },
  cr: {
    name: 'Costa Rica',
    phoneNumbers: ['+1 866 402 11 54']
  },
  hr: {
    name: 'Croatia',
    phoneNumbers: ['0800 223 027']
  },
  cz: {
    name: 'Czech Republic',
    phoneNumbers: ['800 142 238', '800 312 424']
  },
  dk: {
    name: 'Denmark',
    phoneNumbers: ['80 404 998']
  },
  do: {
    name: 'Dominican Republic',
    phoneNumbers: ['1-800-148-5146']
  },
  ee: {
    name: 'Estonia',
    phoneNumbers: ['800 22 20']
  },
  eg: {
    name: 'Egypt',
    phoneNumbers: ['0800 000 9300']
  },
  fi: {
    name: 'Finland',
    phoneNumbers: ['0800 52 3054']
  },
  fr: {
    name: 'France',
    phoneNumbers: ['0800 509 207']
  },
  ge: {
    name: 'Georgia',
    phoneNumbers: ['0800 008 038']
  },
  de: {
    name: 'Germany',
    phoneNumbers: ['0800 400 0230']
  },
  gr: {
    name: 'Greece',
    phoneNumbers: ['00800 3315 0357']
  },
  gt: {
    name: 'Guatemala',
    phoneNumbers: ['1 800 624 0111']
  },
  hn: {
    name: 'Honduras',
    phoneNumbers: ['22 35 70 26']
  },
  hk: {
    name: 'Hong-Kong',
    phoneNumbers: ['800 966 547']
  },
  hu: {
    name: 'Hungary',
    phoneNumbers: ['06 800 153 84']
  },
  is: {
    name: 'Iceland',
    phoneNumbers: ['8004361']
  },
  in: {
    name: 'India',
    phoneNumbers: ['000 800 440 1254', '000 800 440 1380', '000 800 440 1381', '000 800 440 1403']
  },
  id: {
    name: 'Indonesia',
    phoneNumbers: ['001 803 852 7068']
  },
  ie: {
    name: 'Ireland',
    phoneNumbers: ['1800 818 007']
  },
  il: {
    name: 'Israel',
    phoneNumbers: ['180 9471080']
  },
  it: {
    name: 'Italy',
    phoneNumbers: ['800 90 5646']
  },
  jp: {
    name: 'Japan',
    phoneNumbers: ['0120 963 728', '0800 600 1800']
  },
  jo: {
    name: 'Jordan',
    phoneNumbers: ['08 00 226 19']
  },
  ke: {
    name: 'Kenya',
    phoneNumbers: ['0800 721 192']
  },
  kz: {
    name: 'Kazakhstan',
    phoneNumbers: ['8 800 555 7191']
  },
  lv: {
    name: 'Latvia',
    phoneNumbers: ['80200223']
  },
  lt: {
    name: 'Lithuania',
    phoneNumbers: ['8 80022030']
  },
  lb: {
    name: 'Lebanon',
    phoneNumbers: ['01426801', '+8339582965']
  },
  lu: {
    name: 'Luxemborg',
    phoneNumbers: ['800 40 044']
  },
  mk: {
    name: 'Macedonia',
    phoneNumbers: ['38925517546']
  },
  my: {
    name: 'Malaysia',
    phoneNumbers: ['1800 808 933']
  },
  mt: {
    name: 'Malta',
    phoneNumbers: ['800 62 169']
  },
  mu: {
    name: 'Mauritius Island',
    phoneNumbers: ['802 03 3008']
  },
  mx: {
    name: 'Mexico',
    phoneNumbers: ['001 800 252 6138']
  },
  md: {
    name: 'Moldova',
    phoneNumbers: ['0800 61 519']
  },
  nl: {
    name: 'Netherlands',
    phoneNumbers: ['0800 099 4403']
  },
  nz: {
    name: 'New Zealand',
    phoneNumbers: ['0800 000 790']
  },
  no: {
    name: 'Norway',
    phoneNumbers: ['800 62 031']
  },
  om: {
    name: 'Oman',
    phoneNumbers: ['80079796']
  },
  pa: {
    name: 'Panama',
    phoneNumbers: ['00800 226 5505']
  },
  pe: {
    name: 'Peru',
    phoneNumbers: ['0800 54 108', '+51 1 707 5781']
  },
  ph: {
    name: 'Philippines',
    phoneNumbers: ['1 800 1 855 0048']
  },
  pl: {
    name: 'Poland',
    phoneNumbers: ['00 800 331 1316', '00 800 331 1423']
  },
  pt: {
    name: 'Portugal',
    phoneNumbers: ['800 2066 42']
  },
  pr: {
    name: 'Puerto Rico',
    phoneNumbers: ['+1 866 956 7847']
  },
  qa: {
    name: 'Qatar',
    phoneNumbers: ['00800100127']
  },
  re: {
    name: 'Reunion Island',
    phoneNumbers: ['0800 509 207']
  },
  ro: {
    name: 'Romania',
    phoneNumbers: ['0800 833 381']
  },
  ru: {
    name: 'Russia',
    phoneNumbers: ['810 800 2048 1033']
  },
  sa: {
    name: 'Saudi Arabia',
    phoneNumbers: ['8008 44 3241']
  },
  rs: {
    name: 'Serbia',
    phoneNumbers: ['0800 190 183']
  },
  sg: {
    name: 'Singapore',
    phoneNumbers: ['1800 4153094']
  },
  sk: {
    name: 'Slovakia',
    phoneNumbers: ['0800 125 657']
  },
  si: {
    name: 'Slovenia',
    phoneNumbers: ['0800 80 839']
  },
  za: {
    name: 'South Africa',
    phoneNumbers: ['+27 214268189']
  },
  kr: {
    name: 'South Korea',
    phoneNumbers: ['003 083 300 11', '007 988 521 7843']
  },
  es: {
    name: 'Spain',
    phoneNumbers: ['900 210 163']
  },
  lk: {
    name: 'Sri Lanka',
    phoneNumbers: ['(011) 2475663']
  },
  se: {
    name: 'Sweden',
    phoneNumbers: ['020 120 9951', '020 120 3209']
  },
  ch: {
    name: 'Switzerland',
    phoneNumbers: ['0800 142 580']
  },
  tw: {
    name: 'Taiwan',
    phoneNumbers: ['0800 208 177']
  },
  th: {
    name: 'Thailand',
    phoneNumbers: ['001 800 3314 0355']
  },
  tn: {
    name: 'Tunisia',
    phoneNumbers: ['+216 313 00 309']
  },
  tr: {
    name: 'Turkey',
    phoneNumbers: ['00800 448 825 127', '08006212320']
  },
  gb: {
    name: 'United Kingdom',
    phoneNumbers: ['0800 015 9215']
  },
  ae: {
    name: 'United Arab Emirates',
    phoneNumbers: ['8000 3570 3328']
  },
  ua: {
    name: 'Ukraine',
    phoneNumbers: ['0800 50 46 31']
  },
  ug: {
    name: 'Uganda',
    phoneNumbers: ['800113435']
  },
  us: {
    name: 'United States of America',
    phoneNumbers: ['866 402 11 54']
  },
  ve: {
    name: 'Venezuela',
    phoneNumbers: ['0800 100 6013']
  },
  vn: {
    name: 'Vietnam',
    phoneNumbers: ['12032236']
  }
};
